import { FeeConfig } from '@/views/checkout/interfaces';
import { PAYMENT_METHOD_ID } from '@/core/payment-methods/constants';
import { FEE_TYPE } from './fee-type';

export const SERVICE_FEE_CONFIG: FeeConfig = {
    type: FEE_TYPE.Service,
    paymentMethods: [
        PAYMENT_METHOD_ID.CreditCard,
        PAYMENT_METHOD_ID.ApplePay,
        PAYMENT_METHOD_ID.GooglePay,
        PAYMENT_METHOD_ID.SamsungPay,
        PAYMENT_METHOD_ID.Wallet,
        PAYMENT_METHOD_ID.Iris
    ],
    queryParameter: 'servicefee'
};

export const EXTRA_CHARGES_FEE_CONFIG: FeeConfig = {
    type: FEE_TYPE.ExtraCharges,
    queryParameter: 'extracharges'
};

export const SURCHARGE_FEE_CONFIG: FeeConfig = {
    type: FEE_TYPE.Surcharge,
    paymentMethods: [
        PAYMENT_METHOD_ID.CreditCard
    ]
};

export const TBI_BANK_FEE_CONFIG: FeeConfig = {
    type: FEE_TYPE.TbiBankFee,
    queryParameter: 'tbibankfee',
    paymentMethods: [
        PAYMENT_METHOD_ID.TbiBnpl
    ]
};

export const PAY_ON_DELIVERY_CONFIG: FeeConfig = {
    type: FEE_TYPE.PayOnDeliveryFee,
    paymentMethods: [
        PAYMENT_METHOD_ID.PayOnDelivery
    ]
};

export const AVAILABLE_FEE_CONFIGS: Array<FeeConfig> = [
    SERVICE_FEE_CONFIG,
    EXTRA_CHARGES_FEE_CONFIG,
    TBI_BANK_FEE_CONFIG,
    PAY_ON_DELIVERY_CONFIG,
    SURCHARGE_FEE_CONFIG
];
